/**
 * centralEventStream — thin factory around the shared CentralEventStreamClient.
 *
 * Shared transport: @levelup/central-events (parses SSE, exponential backoff,
 * connection state). App-local: CENTRAL_URL config + token/workspace from boot.
 *
 * The factory returns a configured client; the lifecycle (connect/disconnect)
 * is owned by NotificationProvider so we get exactly ONE connection per session.
 *
 * Bearer-only. No cookies. No proxy.
 */

import {
  CentralEventStreamClient,
  type EventHandler,
} from '@levelup/central-events';
import { CENTRAL_URL } from '../config/centralAuth';

export interface EventStreamCallbacks {
  onEvent?: EventHandler;
  onConnected?: () => void;
  onConnectionChange?: (connected: boolean) => void;
  onReconnect?: () => void;
  onError?: (error: Error) => void;
}

export function createEventStreamClient(
  accessToken: string,
  workspaceId: string,
  callbacks: EventStreamCallbacks = {},
): CentralEventStreamClient {
  return new CentralEventStreamClient({
    centralUrl: CENTRAL_URL,
    workspaceId,
    accessToken,
    onEvent: callbacks.onEvent ?? (() => {}),
    onConnected: callbacks.onConnected ?? (() => {}),
    onConnectionChange: callbacks.onConnectionChange ?? (() => {}),
    onReconnect: callbacks.onReconnect ?? (() => {}),
    onError: callbacks.onError,
  });
}
